import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Select,
  MenuItem,
  InputAdornment,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
} from "@mui/material";
import { Person, Search } from "@mui/icons-material";
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { getMembers } from "../api/project";
import { useProject } from "../hooks/project";
import { useUser } from "../hooks/user";
import { searchUser } from "../api/user"
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { addUserToProject } from "../api/member";
import CloseIcon from '@mui/icons-material/Close';
import { ResetPasswordDialog } from "./ResetPasswordRequestDialog";

const OrganizationPage = () => {
  const project = useProject();
  const user = useUser();
  const [searchMember, setSearchMember] = useState("");
  const [searchProjectsMember, setSearchProjectsMember] = useState("");
  const [searchMemberResultList, setSearchMemberResultList] = useState([]);
  const [members, setMembers] = useState([]);
  const [userRole, setUserRole] = useState("");
  const [resetDialogOpen, setResetDialogOpen] = useState(false);


  useEffect(() => {
    getMembersInProject();
  }, []);

  const getMembersInProject = () => {
    getMembers(project.project_id, (data) => {
      if (data) {
        setMembers(data);
        data.map((eachMember) => {
          if (user.id === eachMember.user_id) {
            setUserRole(eachMember.role)
          }
        })
      }
    });
  };

  const handleKeyDownSearchAllMember = (e) => {
    if (e.key === 'Enter') {
      searchAllMemberFromServer(searchMember);
    }
  };

  const searchAllMemberFromServer = () => {
    searchUser(searchMember, (data) => {

      const filterData = data.filter(user => !members.some(members => members.user_id === user.id));
      const updatedData = filterData.map(item => ({
        ...item,
        isSelected: false,
        userRole: "",
      }));
      setSearchMemberResultList(updatedData);
    })
  }

  const handleKeyDownSearchProjectMember = (e) => {
    if (e.key === 'Enter') {
      if (searchProjectsMember !== "") {
        const filterData = members.filter(member => {
          return Object.values(member).some(value => value.includes(searchProjectsMember))
        });
        setMembers(filterData)
      } else {
        getMembersInProject();
      }
    }
  };


  const handleAddUserRole = (index, userID, selectedUserRole) => {
    searchMemberResultList.map((item, idx) => {
      if (idx === index) {
        addUserToProject(userID, project.project_id, selectedUserRole.target.value, (data) => {
          getMembersInProject();
          setSearchMemberResultList([])
        })
        searchAllMemberFromServer()
        return { ...item, userRole: selectedUserRole.target.value }
      }
      return item;
    })

  }
  const handleAddMember = (index) => {
    const updatedData = searchMemberResultList.map((item, idx) => {
      if (idx === index) {
        return { ...item, isSelected: true }
      }
      return item;
    })
    setSearchMemberResultList(updatedData)

  }

  const toggleResetDialog = () => {
    setResetDialogOpen(!resetDialogOpen)
  }

  return (
    <Box sx={{ p: 3, maxWidth: "1200px", margin: "0 auto" }}>
      <Paper sx={{ p: 3, mb: 4 }}>
        {/* User Information Section */}
        <Typography variant="h4" gutterBottom>
          User Information
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 2fr",
            gap: 3,
            alignItems: "center",
          }}
        >
          <Typography>Profile name</Typography>
          <Typography>{user.username}</Typography>

          <Typography>Company</Typography>
          <Typography>{user.company}</Typography>

          <Typography>Email</Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography>{user.email}</Typography>
            <Button variant="contained" color="primary" onClick={toggleResetDialog}>
              Reset Password
            </Button>
            <ResetPasswordDialog
              open={resetDialogOpen}
              setOpen={setResetDialogOpen}
              email={user.email}
              username={user.username}
            />
          </Box>

          <Typography>User Type</Typography>
          <Typography>{userRole}</Typography>
        </Box>
      </Paper>

      {/* Add  Members Section */}
      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Add members
        </Typography>


        <TextField
          placeholder="Search member"
          value={searchMember}
          onChange={(e) => {
            setSearchMember(e.target.value);
          }}
          sx={{ mb: 2 }}
          onKeyDown={handleKeyDownSearchAllMember}
          fullWidth
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />

        <List>
          {searchMemberResultList.map((member, index) => (
            <ListItem
              key={index}
              divider
              sx={{
                display: "grid",
                backgroundColor: '#f0f0f0',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexDirection: 'row',
                  cursor: 'pointer',
                  width: 1000,
                }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Person sx={{ mr: 1 }} />
                  <Typography>{member.first_name}</Typography>
                </Box>
                <Typography>{member.last_name}</Typography>
                <Typography>{member.email}</Typography>
                <Typography>{member.company}</Typography>

                <Button color="primary" onClick={() => handleAddMember(index)} startIcon={<AddIcon />}></Button>
                {member.isSelected && <FormControl sx={{ width: 200 }}>
                  <InputLabel>User Role</InputLabel>
                  <Select
                    value={member.userRole}
                    onChange={(e) => { handleAddUserRole(index, member.id, e) }}
                  >
                    <MenuItem value={"Site Agent"}>Site Agent</MenuItem>
                    <MenuItem value={"Project Admin"}>Project Admin</MenuItem>
                    <MenuItem value={"Geologist"}>Geologist</MenuItem>
                    <MenuItem value={"Driller/operator"}>Driller/operator</MenuItem>
                    <MenuItem value={"GFT"}>GFT</MenuItem>
                    <MenuItem value={"Read Only"}>Read Only</MenuItem>
                  </Select>
                </FormControl>}
              </Box>
            </ListItem>
          ))}
        </List>
      </Paper>


      {/* Members List Section */}
      <Paper sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Organization members
        </Typography>

        <TextField
          placeholder="Search Project Member"
          value={searchProjectsMember}
          onChange={(e) => {
            setSearchProjectsMember(e.target.value);
          }}
          sx={{ mb: 2 }}
          onKeyDown={handleKeyDownSearchProjectMember}
          fullWidth
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />

        <List>
          {members.map((member, index) => (
            <ListItem
              key={index}
              divider
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                py: 1,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Person sx={{ mr: 1 }} />
                <Typography>{member.first_name}</Typography>

                <Typography style={{ marginLeft: '8px' }}>{member.last_name}</Typography>
              </Box>
              <Typography>{member.email}</Typography>
              <Typography>{member.role}</Typography>
            </ListItem>
          ))}
        </List>
      </Paper>

    </Box>
  );
};

export default OrganizationPage;
